import React from 'react';
import { CreditCardNetwork } from '@wix/cashier-common/dist/src/enums/payments/CreditCardNetwork';
import cn from 'classnames';
import { DH } from '../../../utils/DataHook';
import { t } from '../../../utils/i18n';
import { globals } from '../../../utils/globals';
import s from './styles.scss';

interface IIconProps {
  className?: string;
  cardNetwork: CreditCardNetwork;
}
interface IMessageProps {
  onClose: () => void;
}

export const Icon: React.FC<IIconProps> = (props) => (
  <img
    src={`${globals.staticsBaseUrl}/assets/images/cardNetwork/${props.cardNetwork}.svg`}
    className={props.className}
    alt=""
  />
);
Icon.displayName = 'Icon';

interface ToastProps {
  dataHook?: string;
  text: string;
  status: 'success' | 'error';
  onClose: () => void;
}

const Toast: React.FC<ToastProps> = (props) => (
  <section
    data-hook={props.dataHook}
    className={cn(s.toast, {
      [s.errorStatus]: props.status === 'error',
      [s.successStatus]: props.status === 'success',
    })}
  >
    <div>{props.text}</div>
    <div onClick={props.onClose} className={s.cross} />
  </section>
);
Toast.displayName = 'Toast';

export const MarkCardPrimaryErrorMessage: React.FC<IMessageProps> = (props) => (
  <Toast
    status="error"
    dataHook={DH.Toast.FailedToSetAsPrimary}
    text={t('app.card.make-primary.error')}
    onClose={props.onClose}
  />
);
MarkCardPrimaryErrorMessage.displayName = 'MarkCardPrimaryErrorMessage';

export const RemovalErrorMessage: React.FC<IMessageProps> = (props) => (
  <Toast
    status="error"
    dataHook={DH.Toast.FailedToDelete}
    text={t('app.card.details.remove.error')}
    onClose={props.onClose}
  />
);
RemovalErrorMessage.displayName = 'RemovalErrorMessage';

export const CardAddedMessage: React.FC<IMessageProps> = (props) => (
  <Toast
    status="success"
    dataHook={DH.Toast.CardAdded}
    text={t('app.card.details.add.success')}
    onClose={props.onClose}
  />
);
CardAddedMessage.displayName = 'CardAddedMessage';
